import { createContext } from 'react';

type LeftDrawerContextType = {
  showParentChildren: Record<string, boolean>;
  handleLeftDrawerCollapseForParentAlert: (
    alert: any,
    selectedAlert: any,
    dispatch: any,
  ) => void;
  handleLeftDrawerCollapseForChildAlert: (
    alert: any,
    selectedAlert: any,
    dispatch: any,
  ) => void;
};

const LeftDrawerContext = createContext<LeftDrawerContextType>({
  showParentChildren: {},
  handleLeftDrawerCollapseForParentAlert: () => {},
  handleLeftDrawerCollapseForChildAlert: () => {},
});

export default LeftDrawerContext;
